import { graphql } from 'gql';

export const actKc2TotalVersionDetailsGql = graphql(`
    query bimActKC2VersionTotals(
        $skip: Int
        $take: Int
        $actKC2VersionId: Long!
        $where: BimActKC2VersionTotalItemDataFilterInput
        $order: [BimActKC2VersionTotalItemDataSortInput!]
    ) {
        bimActKC2VersionTotals(
            skip: $skip
            take: $take
            actKC2VersionId: $actKC2VersionId
            where: $where
            order: $order
        ) {
            totalCount
            items {
                id
                totalId
                workOrderVersionSeasonId
                workOrderVersionActiveSeasonId
                name
                smrTotal
                ozp
                emm
                zpm
                tzr
                sortOrder
                parentId
                isInflation
                isLimitPrice
            }
        }
    }
`);

export const bimActKC2PriceVersionRowsGql = graphql(`
    query bimActKC2VersionPriceRows(
        $skip: Int
        $take: Int
        $actKC2VersionId: Long!
        $priceLevel: BimPriceLevelEnum!
        $where: BimActKC2VersionPriceRowDataFilterInput
        $order: [BimActKC2VersionPriceRowDataSortInput!]
    ) {
        bimActKC2VersionPriceRows(
            skip: $skip
            take: $take
            actKC2VersionId: $actKC2VersionId
            priceLevel: $priceLevel
            where: $where
            order: $order
        ) {
            totalCount
            items {
                id
                name
                sectionId
                sectionName
                serialNumber
                number
                code
                unit
                quantity
                unitCost
                total
                inactiveMtr
            }
        }
    }
`);
